export default __webpack_public_path__ + "static/media/icon_ads.b981cc2f.svg";